import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import addressReducer from './addressSlice';
import podReducer from './podSlice'
import podTypeReducer from './podTypeSlice'
import schoolReducer from './schoolSlice'
import deliveryRouteReducer from './deliveryRouteSlice';
import mealTypeReducer from './mealTypeSlice'
import menuReducer from './menuSlice'
import subItemReducer from './subItemSlice';
import customerMenuReducer from './customerMenuSlice';
import planTypeReducer from './planTypeSlice'
import plandetailReducer from './planSlice'
import holidaySlice from './holidaySlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    address: addressReducer,
    podType: podTypeReducer,
    pods: podReducer,
    school: schoolReducer,
    deliveryRoute: deliveryRouteReducer,
    mealType: mealTypeReducer,
    menu: menuReducer,
    subItem: subItemReducer,
    customerMenu: customerMenuReducer,
    planType: planTypeReducer,
    plans: plandetailReducer,
    holiday: holidaySlice

    

  },
});

export default store;
